import * as React from "react"
import { Link } from "react-router-dom"
import {NavigationBar, Layout} from "./layout"
import Divider from '@mui/material/Divider';
import Table from 'react-bootstrap/Table';
import { Typography } from "@mui/material";

import Shrugama104 from "./assets/Shrugama_Lines104-108.mp3";
import Shrugama104Pdf from "./assets/Shurangama_Mantra_104_to_108.pdf";
import RebirthMantra from "./assets/Rebirth_Mantra.mp3";
import RebirthMantraPdf from "./assets/Rebirth_Mantra.pdf";
import MedicineMasterMantra from "./assets/Medicine_Master_Mantra.mp3";
import MedicineMasterMantraPdf from "./assets/medicineMasterMantra.pdf";
import GreatCompassionMantra from "./assets/GreatCompassionMantra.mp3";
import GreatCompassionMantraPdf from "./assets/GreatCompassionMantra.pdf";
import GCR from "./assets/Great_Compassion_Repentance.mp3";
import GCRPdf from "./assets/Great_Compassion_Repentance.pdf";
import AmituofoCeremony from "./assets/Sunday_Amitabha_Ceremony.mp3";
import AmituofoCeremonyPdf from "./assets/Amitabha_Sutra.pdf";
import Transference from "./assets/Transference.mp3";
import TransferencePdf from "./assets/Transference.pdf";
import UniversalDoorChapterPdf from "./assets/UniversalDoorChapter.pdf";
import LunchOffering from "./assets/LunchOffering.mp3";
import LunchOfferingPdf from "./assets/Lunch_Offering.pdf";
import BeginMeal from "./assets/BeginMeal.mp3";
import BeginMealPdf from "./assets/BeginMeal.pdf";
import ENdMeal from "./assets/EndMeal.mp3";
import EndMealPdf from "./assets/EndMeal.pdf";
import MorningCeremony from "./assets/morning-recitation.mp3";
import MorningCeremonyPdf from "./assets/MorningCeremony.pdf"
import EveningCeremonyAmitabhaSutraPdf from "./assets/EveningCeremonyAmitabhaSutra.pdf"
import EveningCeremonyAmitabhaSutra from "./assets/Amitabha_Evening.mp3"
import EveningCeremony88BuddhaPdf from "./assets/EveningCeremony88BuddhasRepentance.pdf"
import EveningCeremony88Buddha from "./assets/88_Buddhas_Evening_ceremony.mp3"
import JingDuWenPdf from "./assets/JingDuWen.pdf";
import PurelandHandbook from "./assets/Pure_Land_Dharma_Assembly_Handbook.pdf"
import PuXianVowConduct from "./assets/PuXian_vow_conduct.mp3"
import PuXianVowConductPdf from "./assets/Pu_Xian.pdf"
import RebirthTransference from "./assets/Rebirth_Transference.mp3"
import RebirthTransferencePdf from "./assets/RebirthTransference.pdf"
import PreceptsSamadhiTrueIncensePraise from "./assets/Jie_Ding_Zhen_Xiang.mp3"
import PreceptsSamadhiTrueIncensePraisePdf from "./assets/Precepts_Samadhi_True_Incense_Praise.pdf"
import JeweledCensorPraise from "./assets/Jeweled_Censor_Praise.mp3"
import JeweledCensorPraisePdf from "./assets/Jeweled_Censor_Praise.pdf"
import LiberatingLifeCeremony from "./assets/Liberating_Life_Ceremony.mp3"
import LiberatingLifeCeremonyPdf from "./assets/LiberatingLife.pdf"
import HighKingAvalokitesvaraSutra from "./assets/The_High_King_Avalokitesvara_Sutra.mp3"
import HighKingAvalokitesvaraSutraPdf from "./assets/high_king_avalokitesvara_sutra.pdf"
import UniversalBowing from "./assets/Universal_bowing.mp3"
import UniversalBowingPdf from "./assets/Universal_Bowing.pdf"
import GreatTransference from "./assets/GreatTransference_wLiZu.mp3"
import GreatTransferencePdf from "./assets/GreatTransferenceWLiZu.pdf"
import BathingBuddhaCeremonyPdf from "./assets/Bathing_Buddhas_Ceremony.pdf"
import DailyRecitationHandbook from "./assets/Daily_Recitation_Handbook.pdf"
import mmbrVol1Pdf from "./assets/mmbr1.pdf"
import mmbrVol2Pdf from "./assets/mmbr2.pdf"
import mmbrVol3Pdf from "./assets/mmbr3.pdf"

// navigation bar covers master's head in the image
// do not show image until it is fixed
const heroImage=    <div style={{ display: "grid" }}>
<img
  style={{
    gridArea: "1/1",
    // maxHeight: 600,
  }}
  layout="fullWidth"
  aspectRatio={3 / 1}
  alt=""
  src="/ceremonyBanner.jpg" />
<div
  style={{
    gridArea: "1/1",
    position: "relative",
    placeItems: "center",
    display: "grid",
  }}
>
</div>
</div>


function Ceremonies () {

  return (
    <><NavigationBar/>
    {/* Hero Image */}
    {heroImage}
        {/* Main Content */}
  <Layout>
 <Typography variant="h3"><br /><strong>日誦</strong></Typography>
 <Divider />
 <br/>
<a href={DailyRecitationHandbook}><Typography variant="body1" color = "red"><b> 日誦本 </b></Typography></a><br/>
<br/>
<Typography variant="body1">
<Table bordered hover>
      <thead>
        <tr>
          <th>標題</th>
          <th style={{textAlign:"center"}}>音頻</th>
          <th style={{textAlign:"center"}}>文本</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>早課</td>
          <td style={{textAlign:"center"}}><a href={MorningCeremony}>mp3</a></td>
          <td style={{textAlign:"center"}}><a href={MorningCeremonyPdf}>pdf</a></td>
        </tr>
        <tr>
          <td>​晚課 - 阿彌陀經</td>
          <td style={{textAlign:"center"}}><a href={EveningCeremonyAmitabhaSutra}>mp3</a></td>
          <td style={{textAlign:"center"}}><a href={EveningCeremonyAmitabhaSutraPdf}>pdf</a></td>
        </tr>
        <tr>
          <td>晚課 - 八十八佛大懺悔文</td>
          <td style={{textAlign:"center"}}><a href={EveningCeremony88Buddha}>mp3</a></td>
          <td style={{textAlign:"center"}}><a href={EveningCeremony88BuddhaPdf}>pdf</a></td>
        </tr>
        <tr>
          <td>淨土文 </td>
          <td style={{textAlign:"center"}}><a href="https://dl.chanpureland.org/media/Ceremony/Vow_4_Rebirth_131220.mp3">mp3</a></td>
          <td style={{textAlign:"center"}}><a href={JingDuWenPdf}>pdf</a></td>
        </tr>
      </tbody>
    </Table>
    </Typography>
<br/><br/>
<Typography variant="h3"><br /><strong>誦咒</strong></Typography>
<Typography variant="body1">
<Table bordered hover>
      <thead>
        <tr>
          <th style={{textAlign:"center"}}>標題</th>
          <th style={{textAlign:"center"}}>音頻</th>
          <th style={{textAlign:"center"}}>文本</th>
          <th style={{textAlign:"center"}}>視頻</th>
        </tr>
      </thead>
      <tbody>
      <tr>
          <td >楞嚴咒</td>
          <td style={{textAlign:"center"}}><a href={"/shrugamaMantra.m4a"}>mp3</a></td>
          <td style={{textAlign:"center"}}><a href={"/Shurangama-heart_sutra-complete.pdf"}>pdf</a></td>
          <td style={{textAlign:"center"}}><a href={"/shrugamaMantra.mp4"}>mp4</a></td>
</tr>
        <tr>
          <td >楞嚴咒 544 - 554 行</td>
          <td style={{textAlign:"center"}}><a href={"/Shrugama_Lines544-554.mp3"}>mp3</a></td>
          <td style={{textAlign:"center"}}><a href={"/Shurangama_Mantra_544_to_554.pdf"}>pdf</a></td>
          <td/>
        </tr>
        <tr>
          <td>楞嚴咒 104 - 108 行</td>
          <td style={{textAlign:"center"}}><a href={"/Shrugama_Lines104-108.mp3"}>mp3</a></td>
          <td style={{textAlign:"center"}}><a href={ "/Shurangama_Mantra_104_to_108.pdf"}>pdf</a></td>
          <td/>
        </tr>
        <tr>
          <td>藥師咒</td>
          <td style={{textAlign:"center"}}><a href={MedicineMasterMantra}>mp3</a></td>
          <td style={{textAlign:"center"}}><a href={MedicineMasterMantraPdf}>pdf</a></td>
          <td/>
        </tr>
        <tr>
          <td>往生咒 </td>
          <td style={{textAlign:"center"}}><a href={RebirthMantra}>mp3</a></td>
          <td style={{textAlign:"center"}}><a href={RebirthMantraPdf}>pdf</a></td>
          <td/>
        </tr>
        <tr>
          <td>大悲咒</td>
          <td style={{textAlign:"center"}}><a href={GreatCompassionMantra}>mp3</a></td>
          <td style={{textAlign:"center"}}><a href={GreatCompassionMantraPdf}>pdf</a></td>
          <td/>
        </tr>
        <tr>
          <td>迴向功德</td>
          <td style={{textAlign:"center"}}><a href={Transference}>mp3</a></td>
          <td style={{textAlign:"center"}}><a href={TransferencePdf}>pdf</a></td>
          <td/>
        </tr>
      </tbody>
    </Table>
    </Typography>
    <br/><br/>

    <Typography variant="h3"><br /><strong>週日共修</strong></Typography>
 <Divider />
 <br/>
<a href={PurelandHandbook}><Typography variant="body1" color = "red"><b> 淨土共修課本 </b></Typography></a><br/>
<br/>
<Typography variant="body1">
<Table bordered hover>
      <thead>
        <tr>
          <th style={{textAlign:"center"}}>標題</th>
          <th style={{textAlign:"center"}}>音頻</th>
          <th style={{textAlign:"center"}}>文本</th>
          <th style={{textAlign:"center"}}>視頻</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td >阿彌陀經</td>
          <td style={{textAlign:"center"}}><a href={AmituofoCeremony}>mp3</a></td>
          <td style={{textAlign:"center"}}><a href={AmituofoCeremonyPdf}>pdf</a></td>
          <td style={{textAlign:"center"}}>
            {/* <a href="">mp4</a>&#32;&#32; */}
            <a href="https://www.youtube.com/watch?v=dupWZu4ufTs">youtube</a></td>
        </tr>
        <tr>
          <td>千手千眼大悲懺法</td>
          <td style={{textAlign:"center"}}><a href={GCR}>mp3</a></td>
          <td style={{textAlign:"center"}}><a href={GCRPdf}>pdf</a></td>
          <td style={{textAlign:"center"}}><a href="https://bli.blob.core.windows.net/media/dabeichan.mp4">mp4</a>&#32;&#32;<a href="https://www.youtube.com/watch?v=dRCH3BilYIs">youtube</a></td>
        </tr>
        <tr>
          <td>妙法蓮華經觀世音菩薩普門品</td>
          <td style={{textAlign:"center"}}>
            <a href="https://s3-us-west-1.amazonaws.com/dl.chanpureland.org/media/Ceremony/Ceremonies_SYH_151025_Universal_Door_Chapter.mp3">mp3</a>

          </td>
          <td style={{textAlign:"center"}}><a href={UniversalDoorChapterPdf}>pdf</a></td>
          <td style={{textAlign:"center"}}>
            <a href="https://americanmahayana.blob.core.windows.net/podcast/CeremonyVideo/PuMenPin.mp4">mp4</a>&#32;&#32;<a href="https://www.youtube.com/watch?v=hrCeSGXw2lo" target="_blank">Youtube</a>
          </td>
        </tr>
        <tr>
          <td>大方廣佛華嚴經普賢行願品</td>
          <td style={{textAlign:"center"}}><a href={PuXianVowConduct}>mp3</a></td>
          <td style={{textAlign:"center"}}><a href={PuXianVowConductPdf}>pdf</a></td>
          <td/>
        </tr>
        <tr>
          <td>佛前大供</td>
          <td style={{textAlign:"center"}}><a href={LunchOffering}>mp3</a></td>
          <td style={{textAlign:"center"}}><a href={LunchOfferingPdf}>pdf</a></td>
          <td/>
        </tr>
        <tr>
          <td>臨齋儀：供養偈</td>
          <td style={{textAlign:"center"}}><a href={BeginMeal}>mp3</a></td>
          <td style={{textAlign:"center"}}><a href={BeginMealPdf}>pdf</a></td>
          <td/>
        </tr>
        <tr>
          <td>臨齋儀：結齋偈</td>
          <td style={{textAlign:"center"}}><a href={ENdMeal}>mp3</a></td>
          <td style={{textAlign:"center"}}><a href={EndMealPdf}>pdf</a></td>
          <td/>
        </tr>
        <tr>
          <td>往生迴向</td>
          <td style={{textAlign:"center"}}><a href={RebirthTransference}>mp3</a></td>
          <td style={{textAlign:"center"}}><a href={RebirthTransferencePdf}>pdf</a></td>
          <td/>
        </tr>
        <tr>
          <td>放生</td>
          <td style={{textAlign:"center"}}><a href={LiberatingLifeCeremony}>mp3</a></td>
          <td style={{textAlign:"center"}}><a href={LiberatingLifeCeremonyPdf}>pdf</a></td>
          <td/>
        </tr>
        <tr>
          <td>浴佛節</td>
          <td style={{textAlign:"center"}}><a href="http://s3-us-west-1.amazonaws.com/dl.chanpureland.org/media/Ceremony/110508_00-bathing_buddha_ceremony-2011.mp3">mp3</a></td>
          <td style={{textAlign:"center"}}><a href={BathingBuddhaCeremonyPdf}>pdf</a></td>
          <td/>
        </tr>
        <tr>
          <td>拜願</td>
          <td style={{textAlign:"center"}}><a href={UniversalBowing}>mp3</a></td>
          <td style={{textAlign:"center"}}><a href={UniversalBowingPdf}>pdf</a></td>
          <td/>
        </tr>
        <tr>
          <td>戒定真香</td>
          <td style={{textAlign:"center"}}><a href={PreceptsSamadhiTrueIncensePraise}>mp3</a></td>
          <td style={{textAlign:"center"}}><a href={PreceptsSamadhiTrueIncensePraisePdf}>pdf</a></td>
          <td/>
        </tr>
        <tr>
          <td>寶鼎贊</td>
          <td style={{textAlign:"center"}}><a href={JeweledCensorPraise}>mp3</a></td>
          <td style={{textAlign:"center"}}><a href={JeweledCensorPraisePdf}>pdf</a></td>
          <td/>
        </tr>
        <tr>
          <td>高王觀世音真經</td>
          <td style={{textAlign:"center"}}><a href={HighKingAvalokitesvaraSutra}>mp3</a></td>
          <td style={{textAlign:"center"}}><a href={HighKingAvalokitesvaraSutraPdf}>pdf</a></td>
          <td/>
        </tr>
        <tr>
          <td>佛七大迴向（禮祖）</td>
          <td style={{textAlign:"center"}}><a href={GreatTransference}>mp3</a></td>
          <td style={{textAlign:"center"}}><a href={GreatTransferencePdf}>pdf</a></td>
          <td/>
        </tr>
        <tr>
          <td>藥師佛寳懺 卷一</td>
          <td style={{textAlign:"center"}}><a href="https://s3.us-west-1.amazonaws.com/dl.chanpureland.org/media/Ceremony/MMBR-Vol1+20240714+VXM+VXP+VXR+WMT.mp3">mp3</a></td>
          <td style={{textAlign:"center"}}><a href={mmbrVol1Pdf}>pdf</a></td>
        </tr>
        <tr>
          <td>藥師佛寳懺 卷二</td>
          <td style={{textAlign:"center"}}><a href="https://s3.us-west-1.amazonaws.com/dl.chanpureland.org/media/Ceremony/MMBR-Vol2+20240714+VXM+VXP+VXR+WMT.mp3">mp3</a></td>
          <td style={{textAlign:"center"}}><a href={mmbrVol2Pdf}>pdf</a></td>
        </tr>
        <tr>
          <td>藥師佛寳懺 卷三</td>
          <td style={{textAlign:"center"}}><a href="https://s3.us-west-1.amazonaws.com/dl.chanpureland.org/media/Ceremony/MMBR-Vol3+20240714+VXM+VXP+VXR+WMT.mp3">mp3</a></td>
          <td style={{textAlign:"center"}}><a href={mmbrVol3Pdf}>pdf</a></td>
        </tr>
      </tbody>
    </Table>
    </Typography>
  </Layout></>);
}

export default Ceremonies
